import { render, staticRenderFns } from "./request-item.vue?vue&type=template&id=894a7228&scoped=true"
import script from "./request-item.vue?vue&type=script&lang=js"
export * from "./request-item.vue?vue&type=script&lang=js"
import style0 from "./request-item.vue?vue&type=style&index=0&id=894a7228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894a7228",
  null
  
)

export default component.exports